import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.15.3_@libsql+client@0.14.0_@parcel+watcher@2.5.1_@types+node@22.10.10_better-sql_fd8fa6e89d3511eebb3fc24dc6124ba1/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}